import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const joinGranteeNamesForDisplay = (names: string[]): string => {
  if (names.length <= 3) {
    return names.join(', ');
  }
  return `${names.slice(0, 3).join(', ')}, +${names.length - 3}`;
};

type GrantSummarySectionProps = {
  action?: ReactNode;
  children: ReactNode;
  title: ReactNode;
};

export const GrantSummarySection: FC<GrantSummarySectionProps> = ({ action, children, title }) => (
  <div className="overflow-hidden rounded-lg bg-white">
    <div className="flex items-center justify-between gap-2 bg-gray-50 px-4 py-2">
      <span className="text-sm font-[550] text-gray-700">{title}</span>
      {action}
    </div>
    <div className="rounded-lg rounded-t-none border border-gray-100 px-4 pb-3 pt-3">
      {children}
    </div>
  </div>
);
type GrantSummaryPlainFieldsProps = {
  children: ReactNode;
  className?: string;
};

export const GrantSummaryPlainFields: FC<GrantSummaryPlainFieldsProps> = ({
  children,
  className,
}) => (
  <div
    className={twMerge(
      'h-fit overflow-hidden rounded-lg border border-gray-200 bg-white',
      className,
    )}
  >
    <div className="px-4 py-0">{children}</div>
  </div>
);

type GrantSummaryPlainRowProps = {
  label: ReactNode;
  value: ReactNode;
};

export const GrantSummaryPlainRow: FC<GrantSummaryPlainRowProps> = ({ label, value }) => (
  <div className="flex w-full gap-3 py-2">
    <div className="flex w-[120px] shrink-0">
      <span className="w-fit flex-shrink-0 text-xs font-[450] text-gray-500">{label}</span>
      <span className="text-xs font-[450] text-gray-500">:</span>
    </div>
    <div className="min-w-0 flex-1 text-xs font-[450] text-gray-800">{value}</div>
  </div>
);
